import { Type as T } from '@sinclair/typebox';
import { Value } from '@sinclair/typebox/value';
import { EDisplayFormat } from '../_common/enum.js';
import { validateField } from '../index.js';

export const CreateMediaSchema = T.Object({
  name: T.String({ minLength: 1, error: 'Nome da mídia é um campo obrigatório' }),
  filename: T.String({ minLength: 1, error: 'Nome do arquivo é um campo obrigatório' }),
  brand: T.String({ format: 'uuid', error: 'Marca é um campo obrigatório' }),
  displayFormat: T.Enum(EDisplayFormat, { error: 'Formato de exibição é um campo obrigatório' }),
  duration: T.Number({ error: 'Duração é um campo obrigatório' }),
  size: T.Number({ error: 'Tamanho do arquivo é um campo obrigatório' }),
  extension: T.String({ error: 'Extensão do arquivo é um campo obrigatório' }),
  fileType: T.String({ error: 'Mídia é obrigatória' }),
  thumbnailFileType: T.Optional(T.String({ error: 'Thumbnail é obrigatória' })),
  /** Pre-uploaded thumbnail key from image.uploadCompressed endpoint */
  thumbnailKey: T.Optional(T.String()),
});

export type CreateMediaInputType = typeof CreateMediaSchema.static;

export async function ValidateCreateMediaInput(value: unknown): Promise<CreateMediaInputType> {
  return Value.Parse(CreateMediaSchema, value);
}

export function checkMediaCreateInput(field: string, value: unknown): string | boolean {
  return validateField(CreateMediaSchema, field, value);
}
